// Function to determine the payment type
export const getPaymentType = payment => {
  const paymentNameLower = payment?.PaymentTypeId?.toLowerCase().replace(
    /\s+/g,
    ''
  )

  return {
    isCreditCard:
      paymentNameLower?.includes('claveweb') ||
      paymentNameLower?.includes('tarjetacreditoweb') ||
      paymentNameLower?.includes('credito') ||
      paymentNameLower?.includes('bgcredito') ||
      paymentNameLower?.includes('baccredito'),
    isCreditAccount: paymentNameLower?.includes('creditocomercial'),
    isCmf:
      paymentNameLower?.includes('tdc_cmf') ||
      paymentNameLower?.includes('creditomovilcmf'),
    isYappy:
      paymentNameLower?.includes('bg_yappy') ||
      paymentNameLower?.includes('yappy_bkp'),
    isAch: paymentNameLower?.includes('ach'),
  }
}

// Function to extract the last 4 digits of the credit card
export const getCreditCardLastFourDigits = (payment, isCreditCard, isCmf) => {
  if (isCreditCard || isCmf) {
    return (
      payment?.PaymentAttributes?.find(item =>
        item?.PaymentTypeAttributeId?.includes('Ultimo4Digitos')
      )?.CustomInformation || ''
    ).slice(-4)
  }
  return ''
}

// Function to get the Yappy confirmation number
export const getYappyConfirmationNumber = payment => {
  const CONFIRMATION_NUMBER_ID = 'ConfirmationNumber'
  const paymentMethodAttributes = []

  if (Array.isArray(payment?.PaymentAttributes)) {
    paymentMethodAttributes.push(...payment?.PaymentAttributes)
  } else {
    paymentMethodAttributes.push(payment?.PaymentAttributes)
  }

  const confirmationAttribute = paymentMethodAttributes?.find(
    attribute => attribute?.PaymentTypeAttributeId === CONFIRMATION_NUMBER_ID
  )

  return confirmationAttribute?.CustomInformation
}

// Function to generate the payment label
export const getPaymentLabel = (
  payment,
  isCmf,
  isCreditCard,
  isCreditAccount,
  lastFourDigits,
  creditNumber
) => {
  if (isCmf) return `- ${lastFourDigits} Cuota fija - $`
  if (isCreditAccount) return `- $`
  if (isCreditAccount && creditNumber) return `- ${creditNumber} - $`
  if (isCreditCard && lastFourDigits) return `- ${lastFourDigits} - $`
  if (isCreditCard) return `- $`
  return '- $'
}
